import { render, staticRenderFns } from "./ChallengeCatalogPage.vue?vue&type=template&id=8b9325c6&"
import script from "./ChallengeCatalogPage.vue?vue&type=script&lang=js&"
export * from "./ChallengeCatalogPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports